<template>
  <el-dropdown>
    <div>
      <i class="el-icon-user-solid" />
      <span icon="el-icon-user-solid">{{ user.Dept.Name }}_{{ user.Name }}</span>
      <i class="el-icon-caret-bottom"></i>
    </div>
    <el-dropdown-menu class="usermenus" slot="dropdown">
      <el-dropdown-item icon="el-icon-key" @click.native="onEdit">修改密码</el-dropdown-item>
      <el-dropdown-item icon="el-icon-switch-button" @click.native="onExit">退出系统</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import editpwd from "./editpwd"
export default {
  name: "dropdown",
  data () {
    return {
      user: JSON.parse(localStorage.getItem("user"))
    }
  },
  methods: {
    onEdit () {
      this.$layer.iframe({
        title: "修改密码",
        area: ["400px", "auto"],
        content: {
          content: editpwd,
          parent: this
        }
      })
    },
    onExit () {
      this.$confirm('确定退出管理系统吗?', '退出', {
        center: true,
        type: 'warning'
      }).then(() => {
        this.$router.replace('/login')
      })
    }
  }
};
</script>
